import Vue from 'vue'
import rpTrackerMapper from '@/pages/results/components/filters/filters.tracker.mapper'
import { TIER_TYPES } from '@/utils/constants/results'

const buildRankingClickedEvent = ({
  account: { tier },
  results: { filters, pagination },
  listing: { id: listingId, sourceId, stamps = [] },
  listingPosition,
  expandedResultType = null,
  defaulterAdvertiser = null,
  action,
}) => {
  const {
    hasVirtualTour, amenities = [], stamps: filtersStamps = [],
  } = filters
  const ranking = {
    filter: rpTrackerMapper.filters(filters),
    action,
    pagination: rpTrackerMapper.pagination(pagination),
    listingId,
    listingPosition,
    stamps,
    expandedResultType,
    expandedResultTierType: TIER_TYPES[tier] || 'NO TIER',
    defaulterAdvertiser,
    sourceId,
  }

  ranking.pagination = { ...ranking.pagination }
  ranking.filter.metadata = []
  ranking.filter.amenities = amenities
  ranking.filter.stamps = filtersStamps

  if (hasVirtualTour) {
    ranking.filter.metadata.push('VIRTUAL TOUR')
  }

  if (ranking.sourceId) {
    ranking.sourceId = ranking.listingId
  }

  return {
    ranking,
    event: 'rankingClicked',
  }
}

const rankingClicked = (data) => {
  const event = buildRankingClickedEvent(data)
  Vue.$clickstream.trackEvent(event)
}

export { buildRankingClickedEvent }

export default rankingClicked
